import styled from 'styled-components/macro';
import { colorBlackTransparent600 } from '@yme/tokens/colors';
import { Z_INDEX } from '@yme/tokens/zindex';
export const OverlayStyled = styled.div `
  width: 100%;
  height: 100%;
  max-height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  justify-content: center;
  flex-direction: column;

  z-index: ${Z_INDEX.popupLevel1};

  ${({ isBlurred }) => isBlurred && 'backdrop-filter: blur(6px);'}

  ${({ minHeight }) => minHeight && `min-height: ${minHeight}`};

  background-color: ${colorBlackTransparent600};
`;
